
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './store/reducers';
import RouteProvider from './routes/index';

export const store = createStore( rootReducer );
ReactDOM.render(
    <Provider store={store}>
        <RouteProvider />
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();